"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=MailgunEventResponse.js.map